define([
    'jquery',
    'shared.main.screen',
    'swiper-viewer.bundle'
], function($,screenSize,swiper) {

    // Name the plugin
    var PLUGIN_IDENTIFIER = 'swiperViewer';
    var DEBUG = false;

    var runningDevice,
        pdpSwiperEnabledMobile = WCS_CONFIG.get('PDP::pdpSwiperEnabledMobile') || false,
        pdpSwiperEnabledDesktop = WCS_CONFIG.get('PDP::pdpSwiperEnabledDesktop') || false,
        pdpSwiperEnableFullscreenDesktop = WCS_CONFIG.get('PDP::pdpSwiperEnableFullscreenDesktop') || false,
        autoReplayConfig = JSON.parse(WCS_CONFIG.get('PDP::pdpMediaGalleryVideoPlayerPlayOnScrollConfig'));


    // Create the function that will be bound to JQuery
    var vfdpPlugin = function(element, options) {
        this.element = element;
        this.options = options;
    };

    // Define the plugin's prototype and defaults
    vfdpPlugin.prototype = {
        defaults: {
            swiper: {
                small: {
                    direction: "horizontal",
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    zoom: true,
                    autoHeight: true,
                    spaceBetween: 10
                },
                medium: {
                    zoom: false,
                    spaceBetween: 20,
                    on: {}
                },
                large: {},
                fullscreen: {
                    config: {
                        autoHeight: false,
                        slidesPerView: 1,
                        direction: 'horizontal',
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        },
                        keyboard: {
                            enabled: true,
                        }
                    },
                    common: {
                        containerSelector: '.swiper-layout.swiper-main',
                        innerWrapperSelector: '.swiper-main > .swiper-wrapper',
                    },
                    thumbnails: {
                        config: {
                            autoHeight: false,
                            zoom: false,
                            slidesPerView: 8,
                            direction: 'vertical',
                            freeMode: true,
                            watchSlidesProgress: true
                        },
                        common: {
                            containerSelector: '.swiper-layout.swiper-thumbnails',
                            innerWrapperSelector: '.swiper-thumbnails > .swiper-wrapper'
                        }
                    }
                },
                common: {
                    containerSelector: '.product-views-images.swiper-layout',
                    innerWrapperSelector: '.mol-media-gallery.swiper-wrapper'
                }
            },
            image: {
                zoom: {
                    multiplierScale: 0.80,
                    maxResolution: 2000
                }
            },
            video : {

            },
            masterContainer: '.product-views-container',
            desktopFullscreenWrapper: '.swiper-fullscreen-desktop-container',
            desktopFullscreenCloseButton: '.close-button-fullscreen',
            desktopFullscreenZoomContainer: '.zoom-reset-button',
            desktopFullscreenZoomInButton: '.zoom-in-button',
            desktopFullscreenZoomOutButton: '.zoom-out-button',
            desktopFullscreenZoomResetButton: '.swiper-zoom-panel',
            videoPlayer: '.mol-video-player',
            videoPlayerPlayPause: '.mol-video-player-play-pause-on-click',
            videoContainer: '.mol-media-gallery-video-container',
            videoContainerClass: 'mol-media-gallery-video-container',
            fullscreenActiveClass: 'swiper-fullscreen',
            labelOf: ' / '
        },

        /**
         * init()
         * Initializes the plugin instance
         * @returns {Object} This plugin instance
         */
        init: function() {
            var self = this;

            if(DEBUG) console.debug('Initializing ', PLUGIN_IDENTIFIER, 'on', $(self.element));

            self.defaults.swiper.small.on = {
                zoomChange:function(swiper, scale, imageEl, slideEl) {
                    self.setImageDetails(slideEl);
                    self.refreshImageQuality(swiper, scale, imageEl, slideEl);
                },
                slideChangeTransitionEnd:function(swiper) {
                    self.setImageDetails();
                },
                init:function(swiper) {
                    self.setImageDetails();
                    self.handleVideoSlideEvents(swiper);
                },
                slideChange:function(swiper) {
                    self.handleVideoSlideEvents(swiper);
                    if( self.$prevButton && self.$nextButton ){
                        self.updateNavigationButtonState(swiper);
                    }
                }
            };

            self.mergeConfigs();

            // Initialize events
            self.events();

            // Initialize Swiper Viewer
            self.initSwiperViewer();

            $.pubsub('publish','swiperViewer.init.ready');

            return self;
        },

        mergeConfigs: function() {
            var self = this;
            // Merge various methods of providing plugin options into a single config object
            self.metadata = $(self.element).data(PLUGIN_IDENTIFIER+'Options');

            self.config = $.extend(
                true, // perform deep copy
                {}, // empty object to merge into
                self.defaults, // defaults hardcoded into the prototype defined in this file
                self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
                self.metadata // options provided as HTML data attribute $(selector).data()
            );
            self.zoomMultiplierScale = parseFloat(self.config.image.zoom.multiplierScale);
            self.maxResolution = parseFloat(self.config.image.zoom.maxResolution);
        },

        initSwiperViewer: function (fullscreenThumbViewer,isFullscreenModal) {
            var self = this;

            self.mergeConfigs();
            if (isFullscreenModal) {
                self.config.swiper.common.containerSelector = '.reveal-overlay.swiper-layout';
                self.config.swiper.common.innerWrapperSelector = '.reveal-overlay.modal-images-gallery';
                self.config.swiper.small.slidesPerView = $('.mol-media-gallery .mol-media-gallery__cell').length;
                self.config.swiper.small.pagination = false;
            }
            runningDevice = screenSize.size();
            var configCurrentViewPort = null;
            var configCommon = self.config.swiper.common;
            var isFullscreenThumb = false;

            if (pdpSwiperEnabledMobile || pdpSwiperEnabledDesktop) {
                if (runningDevice === 'small' && pdpSwiperEnabledMobile) {
                    $('.swiper-hero-placeholder-viewer').addClass('fade-out');
                    self.unwrapSwiperSlides(self.config.swiper.common.innerWrapperSelector);
                    configCurrentViewPort = self.config.swiper.small;
                    if( !isFullscreenModal && configCurrentViewPort.pagination.type && configCurrentViewPort.pagination.type === 'fraction' ){
                        configCurrentViewPort.pagination.renderFraction = function (currentClass, totalClass) {
                            return '<span class="swiper-pagination-container"><span class="swiper-button-prev-custom"></span> <span class="' + currentClass + '"></span>' +  self.config.labelOf + '<span class="' + totalClass + '"></span> <span class="swiper-button-next-custom"></span></span><span class="fullscreen-container"></span>';
                        };
                    }

                } else if (runningDevice === 'medium' && pdpSwiperEnabledDesktop) {
                    configCurrentViewPort = $.extend(self.config.swiper.small, self.config.swiper.medium);
                } else if ((runningDevice === 'large' || runningDevice === 'xlarge') && pdpSwiperEnabledDesktop) {
                    configCurrentViewPort = $.extend(self.config.swiper.small, self.config.swiper.medium, self.config.swiper.large);
                } else if (runningDevice !== 'small' && pdpSwiperEnableFullscreenDesktop && self.desktopFullscreenInitialized) {
                    var fullscreenConfig;
                    if (!fullscreenThumbViewer) {
                        isFullscreenThumb = true;
                        fullscreenConfig = self.config.swiper.fullscreen.thumbnails.config;
                        configCommon= self.config.swiper.fullscreen.thumbnails.common;
                    } else {
                        fullscreenConfig = self.config.swiper.fullscreen.config;
                        configCommon = self.config.swiper.fullscreen.common;
                        fullscreenConfig.thumbs = {
                            swiper: fullscreenThumbViewer
                        };
                    }
                    configCurrentViewPort = $.extend(self.config.swiper.small, fullscreenConfig);
                    configCurrentViewPort.on.zoomChange = function (swiper, scale, imageEl, slideEl) {
                        self.zoomChangeButtonStates(scale === 1);
                        self.refreshImageQuality(swiper, scale, imageEl, slideEl);
                    };
                }
            }
            if (configCurrentViewPort != null) {
                // if the current setup is successfully initialized commit all local settings to the "self" object
                self.configCurrentViewPort = configCurrentViewPort;
                self.configCurrentSwiperCommon = configCommon;
                self.containerElement = $(configCommon.containerSelector);
                self.swiperViewer = new swiper (configCommon.containerSelector, configCurrentViewPort);

                if( configCurrentViewPort.pagination.type && configCurrentViewPort.pagination.type === 'fraction' ) {
                    self.$prevButton = $('.swiper-button-prev-custom');
                    self.$nextButton = $('.swiper-button-next-custom');
                    self.setupCustomNavigationButtons(self.swiperViewer);
                }

                $(self.config.masterContainer).addClass('swiper-style');
                if (isFullscreenThumb) {
                    // init the desktop fullscreen viewer after its thumbnails viewer is ready
                    self.initSwiperViewer(self.swiperViewer);
                    self.desktopFullscreenSwiperReady = true;
                }
            }
        },

        unwrapSwiperSlides: function(innerWrapperSelector) {
            var $innerWrapper = $(innerWrapperSelector);
            var $slides = $innerWrapper.find('.mol-media-gallery__row.swiper-slide');
            $slides.siblings(':not(.swiper-slide)').addClass('hide');
            if ($slides.length > 0) {
                $slides.each(function (index, row) {
                    $(row).find('.mol-media-gallery__cell').unwrap().attr('data-row-index', index).addClass('swiper-slide');
                });
            }
        },

        /**
         * Binds plugin events
         **/
        events: function () {
            var self = this;
            $.pubsub('subscribe','swiperViewer.INIT_FULLSCREEN', function(event, data) {
                self.initSwiperViewer(null,true);
            });

            $.pubsub('subscribe','swiperViewer.UPDATE', function(event, data) {
                self.desktopFullscreenSwiperReady = false;
                if ( self.swiperViewer ) {
                    self.swiperViewer.destroy();
                    self.swiperViewer = undefined;
                }
                $('.swiper-style').attr('style','');
                if (self.desktopFullscreenInitialized) {
                    self.copyMediaContentToFullscreenWrappers();
                }
                self.initSwiperViewer();
                if (!self.desktopFullscreenSwiperReady) {
                    var readyEvent = document.createEvent('Event');
                    // Define that the event name is 'build'.
                    readyEvent.initEvent('init.viewer.complete.ready', true, true);
                    // target can be any Element or other EventTarget.
                    document.dispatchEvent(readyEvent);
                }
            });

            $.pubsub('subscribe', 'swiperViewer.fullscreenDesktop.requestFullscreen', function(event, data) {
                if (self.desktopFullscreenSwiperReady) {
                    if (data && data.swiperIndex != null) {
                        self.setActiveSlide(data.swiperIndex);
                        self.scheduleImageDetailsRefresh = true;
                    }
                    self.requestFullscreen();
                }
            });

            $.pubsub('subscribe', 'swiperViewer.fullscreenDesktop.init', function(event, data) {
                if (pdpSwiperEnableFullscreenDesktop && !self.desktopFullscreenInitialized) {
                    // setup desktop fullscreen's initial dom and events
                    self.setupFullscreenDom();
                    self.setupFullscreenEvents();
                    self.desktopFullscreenInitialized = true;
                    $.pubsub('publish','swiperViewer.UPDATE'); // reinit the swiper component
                }
            });

            $(window).resize(function() {
                clearTimeout(self.resizeTimer);
                self.resizeTimer = setTimeout(function() {
                    self.changeSwiperDevice();
                  }, 250);
            });
        },


        fullscreenChangeHandler: function () {
            var self = this;
            if (!document.fullscreenElement && self.fullscreenElement.hasClass(self.config.fullscreenActiveClass)) {
                self.fullscreenElement.removeClass(self.config.fullscreenActiveClass);
            }
        },

        fullscreenTriggerExit: function () {
            var self = this;
            if (document.fullscreenElement) {
                document.exitFullscreen();
            }
        },

        requestFullscreen: function () {
            var self = this;
            if (self.fullscreenElement && self.fullscreenElement.length && self.fullscreenElement[0].requestFullscreen) {
                self.fullscreenElement.addClass(self.config.fullscreenActiveClass);
                self.fullscreenElement[0].requestFullscreen().catch(function (err) {
                    self.fullscreenElement.removeClass(self.config.fullscreenActiveClass);
                });
            }
        },

        setupFullscreenEvents: function() {
            var self = this;
            document.addEventListener("fullscreenchange", self.fullscreenChangeHandler.bind(self));

            var fullscreenCloseButton = self.fullscreenElement.find(self.config.desktopFullscreenCloseButton);
            fullscreenCloseButton.off('click');
            fullscreenCloseButton.on('click', self.fullscreenTriggerExit.bind(self));

            self.fullscreenZoomInButton = self.fullscreenElement.find(self.config.desktopFullscreenZoomInButton);
            self.fullscreenZoomInButton.off('click');
            self.fullscreenZoomInButton.on('click', self.zoomInButtonHandler.bind(self));
            self.fullscreenZoomOutButton = self.fullscreenElement.find(self.config.desktopFullscreenZoomOutButton);
            self.fullscreenZoomOutButton.off('click');
            self.fullscreenZoomOutButton.on('click', self.zoomOutButtonHandler.bind(self));
            self.fullscreenZoomResetButton = self.fullscreenElement.find(self.config.desktopFullscreenZoomResetButton);
            self.fullscreenZoomResetButton.off('click');
            self.fullscreenZoomResetButton.on('click', self.zoomOutButtonHandler.bind(self));
        },

        setupCustomNavigationButtons: function(viewer) {
            var self = this;
            self.$nextButton.on('click', function(){
                viewer.slideNext(200, false);
            });

            self.$prevButton.on('click', function(){
                viewer.slidePrev(200, false);
            });
            self.updateNavigationButtonState(viewer);
        },

        updateNavigationButtonState: function(viewer) {
            var self = this;
            self.$prevButton.removeClass('disabled');
            self.$nextButton.removeClass('disabled');

            if( viewer.activeIndex === 0 ){
                self.$prevButton.addClass('disabled');
            }
            if( viewer.activeIndex >= viewer.slides.length -1 ){
                self.$nextButton.addClass('disabled');
            }
        },

        zoomInButtonHandler: function($event) {
            var self = this;
            $event.stopPropagation();
            if (self.swiperViewer && self.swiperViewer.zoom && self.zoomMultiplierScale) {
                if (self.swiperViewer && self.swiperViewer.touches) {
                    self.swiperViewer.zoom.image.touchesCurrent = {};
                    self.swiperViewer.zoom.image.touchesStart = {};
                }
                self.swiperViewer.zoom.in(self.zoomMultiplierScale);
            }
        },

        zoomOutButtonHandler: function($event) {
            var self = this;
            $event.stopPropagation();
            if (self.swiperViewer && self.swiperViewer.zoom) {
                self.swiperViewer.zoom.out();
            }
        },

        zoomChangeButtonStates: function(isZoomedOut) {
            var self = this;
            var pressedButton = self.fullscreenZoomInButton;
            var oppositeButton = self.fullscreenZoomOutButton;
            if (isZoomedOut) {
                pressedButton = self.fullscreenZoomOutButton;
                oppositeButton = self.fullscreenZoomInButton;
            }
            pressedButton.prop('disabled', true);
            pressedButton.attr('tabindex', '-1');
            pressedButton.attr('aria-disabled', 'true');
            oppositeButton.prop('disabled', false);
            oppositeButton.attr('tabindex', '0');
            oppositeButton.removeAttr('aria-disabled');
        },

        changeSwiperDevice: function () {
            var self = this;
            if (runningDevice != screenSize.size()) {
                //$.pubsub('publish', 'mol-media-gallery.refresh');
                self.refreshMolMediaViewer();
                $.pubsub('publish', 'swiperViewer.UPDATE');
            }
        },

        refreshImageQuality: function (swiperViewer, scale, imageEl, slideEl) {
            var self = this,
                newHeight,
                newWidth;
            var roundedNewScale = Math.round(scale, 1),
                roundedCurrentScale = Math.round(swiperViewer.zoom.currentScale, 1);
            if (self.scheduleImageDetailsRefresh || !self.activeSlide) {
                var currentSlideImage = $(slideEl);
                if (!currentSlideImage.length) {
                    return;
                }
                self.setImageDetails(currentSlideImage);
            }
            if (roundedNewScale !== roundedCurrentScale && roundedNewScale <= swiperViewer.zoom.gesture.maxRatio) {
                if (roundedNewScale === 1) {
                    newHeight = self.activeSlide.originalResolution.hei;
                    newWidth = self.activeSlide.originalResolution.wid;
                } else {
                    newHeight = ((parseInt(self.activeSlide.originalResolution.hei)  * roundedNewScale) * self.zoomMultiplierScale);
                    newWidth = (parseInt(self.activeSlide.originalResolution.wid)  * roundedNewScale) * self.zoomMultiplierScale;
                }
            }
            if ((newWidth != 0 && newHeight != 0) && (typeof newWidth != 'undefined' && typeof newHeight != 'undefined') && (swiperViewer.lastScaleUpdated != roundedNewScale)) {
                if (newWidth > self.maxResolution || newHeight > self.maxResolution) {
                    newWidth = self.maxResolution;
                    newHeight = self.maxResolution;
                }
                swiperViewer.lastScaleUpdated = roundedNewScale;
                var $swiperSlide = $(slideEl);
                var isAdaptiveImage = $swiperSlide.find('picture').length > 0;
                var wid = parseInt(newWidth);
                var hei = parseInt(newHeight);
                if (isAdaptiveImage) {
                    if(self.activeSlide.originalResolution && self.activeSlide.originalResolution.hei && self.activeSlide.originalResolution.wid){
                        var newQueryParams = $.extend({}, self.activeSlide.originalResolution);
                        newQueryParams.wid = wid;
                        newQueryParams.hei = hei;
                        $swiperSlide.find('img').attr('srcset', self.activeSlide.imageUrl + '?' + $.param(newQueryParams));
                    }
                    else{
                        $swiperSlide.find('img').attr('srcset', self.activeSlide.imageUrl + '?wid=' + wid + '&hei=' + hei);
                    }
                }
                $swiperSlide.find('img').attr('src', self.activeSlide.imageUrl + '?wid=' + wid + '&hei=' + hei);
            }
        },

        refreshMolMediaViewer: function () {
            var self = this;
            if (runningDevice === 'small') { //when switching from small device to medium/large/xlarge
                var $cells = self.containerElement.find('.mol-media-gallery__cell');
                $cells.siblings(':not(.swiper-slide)').removeClass('hide');
                var rows = {};
                $cells.each(function (index, cell) {
                    var $cell = $(cell),
                        rowIndex = $cell.attr('data-row-index');
                    if (rows[rowIndex]) {
                        $cell.appendTo(rows[rowIndex]);
                    } else {
                        $cell.wrap('<div class="mol-media-gallery__row swiper-slide"></div>');
                        rows[rowIndex] = $cell.parent();
                    }
                });
                $cells.removeAttr('role');
                $cells.removeAttr('aria-label');
                $cells.removeClass('swiper-slide');
                $('.color-swatches-action-js').css('display', 'none');
            } else if (screenSize.size() === 'small') { //when switching from medium/large/xlarge device to small
                var $selectionDetails = $('.section-2, .section-3, .section-reviews'),
                    $sectionReviews = $('.section-reviews'),
                    $productDetailGalleryEnabled = $('.product-detail.media-gallery-enabled'),
                    section = [],
                    $mainPanelWrapper = $('.main-panel-wrapper');

                for (var i = 1; i <= 4; i++) { // Getting selectors from sections 1-4
                    section[i] = $('.section-' + i);
                }

                if ($('.mol-sticky-inner-sidebar').html() != '') {
                    $selectionDetails.removeClass('attached-to-sticky');

                    if ($sectionReviews.hasClass('section-top')) {
                        $([$sectionReviews[0], $(section[2])[0], $(section[3])[0]]).appendTo($productDetailGalleryEnabled);
                    } else {
                        $([$(section[2])[0], $(section[3])[0]]).appendTo($productDetailGalleryEnabled);
                    }

                    $(section[1]).insertAfter($mainPanelWrapper);
                    $(section[4]).insertAfter($(section[3]));
                }
            }
        },

        setImageDetails: function ($image) {
            var self = this,
                swiperSlideActive = $image;
            if ((!swiperSlideActive || !swiperSlideActive.length)) {
                swiperSlideActive = $($image).find('img');
            }
            if (swiperSlideActive.length > 0) {
                var imageUrl = swiperSlideActive.attr('src').split('?')[1];
                var queryParams = imageUrl.substring(imageUrl.indexOf('?') + 1).split('&');
                for (var i = 0, result = {}; i < queryParams.length; i++) {
                    queryParams[i] = queryParams[i].split('=');
                    result[queryParams[i][0]] = decodeURIComponent(queryParams[i][1]);
                }
                if( queryParams.length === 1) { // Assuming that the only param is the scene7 preset, which doesn't contain wid hei and etc.
                    result = {hei: swiperSlideActive.height(), wid: swiperSlideActive.width()};
                }
                if ( typeof self.activeSlide == 'undefined' || ( typeof self.activeSlide != 'undefined' && self.activeSlide.imageUrl != swiperSlideActive.attr('src').split('?')[0])) {
                    self.activeSlide = {
                        "imageUrl": swiperSlideActive.attr('src').split('?')[0],
                        "originalResolution": result
                    };
                }
                self.scheduleImageDetailsRefresh = false;
            }
        },

        handleVideoSlideEvents: function (swiper) {
            var self = this,
                $wrapper = $(swiper.el),
                videoPlayer = $wrapper.find(self.config.videoPlayer),
                $activeSlide = $(swiper.slides[swiper.activeIndex]),
                isFullscreenSwiper = $wrapper.closest(self.config.swiper.fullscreen.common.containerSelector).length;

            if (isFullscreenSwiper) {
                var zoomContainer = self.fullscreenElement.find(self.config.desktopFullscreenZoomResetButton);
                if ($activeSlide.hasClass(self.config.videoContainerClass)) {
                    zoomContainer.addClass('hide');
                } else {
                    zoomContainer.removeClass('hide');
                }
            }

            if (autoReplayConfig.enabled) {
                if ($activeSlide.hasClass(self.config.videoContainerClass)) {
                    if (videoPlayer.get(0).muted === false) {
                        videoPlayer.get(0).muted = true;
                    }
                    videoPlayer.get(0).play();
                    self.handleVideoEvents($wrapper);
                } else if (videoPlayer.length > 0 && !(videoPlayer.get(0).paused)) {
                    videoPlayer.get(0).pause();
                    videoPlayer.get(0).currentTime = 0;
                }
            }
        },

        setActiveSlide: function(index) {
            var self = this;
            if (self.swiperViewer) {
                self.swiperViewer.slideTo(index, 0, true);
            }
        },

        isFullscreen: function() {
            var self = this;
            return self.containerElement && $(self.containerElement).closest(self.config.desktopFullscreenWrapper).length;
        },

        setupFullscreenDom: function() {
            var self = this;
            var htmlStringToInsert = '<div class="swiper-fullscreen-desktop-container">' +
                '<div class="swiper-fullscreen-desktop-container-inner">' +
                '<div thumbsSlider="" class="swiper-layout swiper-thumbnails"><div class="swiper-wrapper"></div></div>' +
                '<div class="swiper-layout swiper-main"><div class="swiper-wrapper"></div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div></div>' +
                '<button type="button" class="close-button-fullscreen"></button>' +
                '<div class="swiper-zoom-panel"><div class="swiper-zoom-panel-inner"><button class="button zoom-in-button" role="button" tabindex="0" aria-label="Zoom in"></button><button class="button zoom-out-button" tabindex="-1" role="button" aria-label="Zoom out" disabled aria-disabled="true"></button><button class="button zoom-reset-button" tabindex="0" role="button" aria-label="Reset zoom"></button></div></div>' +
                '</div>' +
                '</div>';
            $(self.config.masterContainer).prepend(htmlStringToInsert);
            self.fullscreenElement = $(self.config.desktopFullscreenWrapper);
        },

        copyMediaContentToFullscreenWrappers: function() {
            var self = this;
            var $swiperWrapper = $(self.config.swiper.common.innerWrapperSelector);
            var swiperFullscreenDesktopMainWrapperPlaceholder = self.fullscreenElement.find('.swiper-main .swiper-wrapper');
            var swiperFullscreenDesktopThumbWrapperPlaceholder = self.fullscreenElement.find('.swiper-thumbnails .swiper-wrapper');
            swiperFullscreenDesktopMainWrapperPlaceholder.empty();
            swiperFullscreenDesktopThumbWrapperPlaceholder.empty();
            var existingSwiperContentMain = $swiperWrapper.children().clone();
            var existingSwiperContentThumb = $swiperWrapper.children().clone();
            existingSwiperContentMain.appendTo(swiperFullscreenDesktopMainWrapperPlaceholder);
            existingSwiperContentThumb.appendTo(swiperFullscreenDesktopThumbWrapperPlaceholder);

            self.unwrapSwiperSlides(self.config.swiper.fullscreen.common.innerWrapperSelector);
            self.unwrapSwiperSlides(self.config.swiper.fullscreen.thumbnails.common.innerWrapperSelector);

            swiperFullscreenDesktopMainWrapperPlaceholder.find('.swiper-slide').each(function (index, item) {
                var $slide = $(item),
                    $overlay = $slide.find('.mol-media-gallery__cell__overlay'),
                    $img = $slide.find('img'),
                    $pictureSrcs = $slide.find('picture > source, picture > img'),
                    overlayImgUri = $overlay.data('preview-image-uri');
                if (overlayImgUri) {
                    $img.attr('src', overlayImgUri);
                    $pictureSrcs.attr('srcset', overlayImgUri);
                }
            });

            var $innerWrapper = $(self.config.swiper.fullscreen.common.innerWrapperSelector).add(self.config.swiper.fullscreen.thumbnails.common.innerWrapperSelector);
            var slides = $innerWrapper.find('.swiper-slide');
            slides.not(self.config.videoContainer).attr('class', 'swiper-slide');
            slides.filter(self.config.videoContainer).each(function (index, item) {
                var classesForRemoval = Array.from(item.classList).filter(function(clss) {
                    return clss.startsWith('mol-media-gallery__');
                });
                $(item).removeClass(classesForRemoval);
            });
            var $overlays = $innerWrapper.find('.mol-media-gallery__cell__overlay');
            $overlays.remove();
            var $zoomIcons = $innerWrapper.find('.mol-media-gallery__zoom-icon');
            $zoomIcons.remove();
            var $emptyCell = $innerWrapper.find('.mol-media-gallery__empty-cell');
            $emptyCell.remove();
            $innerWrapper.find('.mol-media-gallery-image-wrapper > .swiper-zoom-container').unwrap();

            self.initVideoEvents(swiperFullscreenDesktopMainWrapperPlaceholder);
            self.handleVideoEvents(swiperFullscreenDesktopThumbWrapperPlaceholder);
        },

        initVideoEvents: function($wrapper) {
            if(!$wrapper) {
                return;
            }
            var self = this,
                videoPlayPause = $wrapper.find(self.config.videoPlayerPlayPause);
            if(videoPlayPause.length) {
                videoPlayPause.on('click', self.videoPlayPause.bind(self));
                videoPlayPause.attr('controls', false);
                self.handleVideoEvents($wrapper);
            }
        },

        videoPlayPause: function ($event) {
            var self = this,
                video = $event.currentTarget,
                $video = $(video),
                videoContainer = $video.closest(self.config.videoContainer);
            if (!videoContainer.length) {
                return;
            }
            $event.preventDefault();
            $event.stopPropagation();
            if (video.paused) {
                video.play();
                videoContainer.removeClass('custom-video-play-btn');
                videoContainer.addClass('custom-video-pause-btn');

                if (!$video.is(self.config.videoPlayerPlayPause)) {
                    $video.attr('controls', true);
                }
            } else {
                video.pause();
                videoContainer.addClass('custom-video-play-btn');
                videoContainer.removeClass('custom-video-pause-btn');

                if (!$video.is(self.config.videoPlayerPlayPause)) {
                    $video.attr('controls', false);
                }
            }
        },

        handleVideoEvents: function ($wrapper) {
            if (!$wrapper) {
                return;
            }
            var self = this,
                video = $wrapper.find(self.config.videoPlayerPlayPause),
                videoContainer = $wrapper.is(self.config.videoContainer) ? $wrapper :  $wrapper.find(self.config.videoContainer);
            if (!video.length || !videoContainer.length) {
                return;
            }

            videoContainer.removeClass('custom-video-play-btn custom-video-pause-btn');

            // Check whether the video is playing or not to add icon accordingly
            if (video.get(0).paused) {
                videoContainer.addClass('custom-video-play-btn');
            } else {
                videoContainer.addClass('custom-video-pause-btn');
            }
        }
    };

    // Create the instance defaults from the prototype
    vfdpPlugin.defaults = vfdpPlugin.prototype.defaults;

    // Register as a JQuery plugin and prevent duplicate instantiation
    $.fn[PLUGIN_IDENTIFIER] = function(options) {
        return this.each(function() {
            var instance = $(this).data(PLUGIN_IDENTIFIER);
            if(!instance) {
                instance = new vfdpPlugin(this, options).init();
                $(this).data(PLUGIN_IDENTIFIER, instance);
            }
        });
    };
});
